import PageLoader from './utils/PageLoader';
import PageComponentLoader from './utils/PageComponentLoader';

import { pages } from './pages';
import { components } from './components';

(function ($) {
  const pageLoader = new PageLoader(pages);
  const cLoader = new PageComponentLoader(components);

  $(document).ready(() => {
    if (pages.length) {
      pageLoader.load();
    }

    if (components) {
      cLoader.load();
    }
  });

  window.$ = $;
}(jQuery));




// WEBPACK FOOTER //
// ./src/js/main.js